<template>
  <v-container fluid class="home">
    <notification-popup
      :dialog="notifSuccess"
      :contentMsg="$t('TicketHasBeenAddCart')"
      :headerMsg="$t('Success')"
      :nameBtnNo="$t('ViewAnotherTicket')"
      :nameBtnYes="$t('ViewCart&CheckOut')"
      :imgSource="'transactions/success.svg'"
      colorIcon="success"
      typeModal="dialog"
      Icon="mdi-check-circle"
      :outlinedBorderBtnNo="false"
      :onHandlerYes="buttonOke"
      :onHandlerNo="buttonNo"
    />

    <notification-popup
      :dialog="notifFailed"
      :contentMsg="$t('notifTicketFailedAdd')"
      :headerMsg="$t('Failed')"
      :nameBtnNo="$t('labelNo')"
      :nameBtnYes="$t('TryAgain')"
      colorIcon="danger"
      typeModal="transaction"
      disableBtnNo="true"
      Icon="mdi-close-circle"
      :onHandlerYes="buttonOkeFailed"
    />

    <RouteInformation
      :routeTitle="itemRoute.routeLongName"
      :keyItem="itemRoute.fareID"
      :origin="itemRoute.origin_loc"
      :ToOrig=itemRoute.routeLoc
      :destination="itemRoute.destination_loc"
      :ToDest=itemRoute.routeLoc
      :dialog="routeInformationDialog"
      :orig="itemRoute.origin_code"
      :dest="itemRoute.destination_code"
      :expiredNote="itemRoute.expiredNote"
      :validate_close_date="itemRoute.validate_close_date"
      :validate_open_date="itemRoute.validate_open_date"
      :fare-rule="itemRoute.fareRule"
      :RouteCode="itemRoute.routeShortName"
      :price="itemRoute.price"
    />
    <v-row v-if="item.length===0 && isTicketLoaded" justify="center" class="center-no-ticket p-0">
      <v-col class="d-flex justify-center p-0" cols="12">
        <v-img
          :src="require('@/assets/icon/no-ticket.svg')"
        ></v-img>
      </v-col>
      <v-col class="text-center p-0">
        <h3 class="font-weight-bold">{{ $t("NoTicket") }}</h3>
      </v-col>
    </v-row>
    <ListofTicket
      v-else
      :item="item"
      :clickRouteInformation="clickRouteInformation"
      :togglebuy="togglebuy"
    />
    <v-row class="d-flex justify-center mt-3" v-if="eof && hasScroll">
      <b>{{ $t("Eof") }}</b>
    </v-row>

    <v-footer v-if="$partnerACL.isShowButton('cart')" fixed app width="auto" color="white" elevation="3">
      <v-container>
        <v-row class="pa-0 ma-0">
          <v-col cols="12" align-self="center">
            <ac-button 
              :active="$partnerACL.isShowButton('cart')"
              :name="$t('AddToCart')" 
              :on-click-handler="()=>addToCart(item)"
              :is-disabled="buttonDisabled"
              width="100%"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </v-container>
</template>

<script>
import store from "@/store";
import NotificationPopup from "@/components/NotificationPopup.vue";
// import CardBuyTicket from "@/components/CardBuyTicket.vue";
import RouteInformation from "@/components/RouteInformation.vue";
import ListofTicket from "@/components/ListofTicket.vue";
import AcButton from "@/components/AcButton.vue";
import moment from "moment";
export default {
  name: "FlateFare",
  components: { RouteInformation, NotificationPopup, ListofTicket, AcButton },
  data() {
    return {
      searchticket: "",
      routeInformationDialog: false,
      notifSuccess: false,
      notifFailed: false,
      selected: [],
      item: [],
      page: 0,
      limit: 20,
      bottom: false,
      isEnd: false,
      buttonDisabled: false,
      customerID: store.state.auth.userData.customerID,
      eof: false,
      lastPage: 2,
      hasScroll: false,
      isTicketLoaded: false,
    };
  },
  computed: {
    itemRoute() {
      return this.$store.state.moduleUi.routeInformation;
    },
  },
  watch: {
    bottom(bottom) {
      if (bottom & !this.isEnd) {
        this.addData();
      }
    },
    itemRoute() {
      if (this.itemRoute == "") {
        this.routeInformationDialog = false;
      } else {
        this.routeInformationDialog = true;
      }
    },
    item: {
      handler: function () {
        if (this.item.filter((item) => item.is_buy == true).length > 0) {
          this.buttonDisabled = false;
        } else {
          this.buttonDisabled = true;
        }
      },
      deep: true,
    },
    buttonDisabled() {
      let data = this.item.filter((item) => item.is_buy == true);
      if (data.length < 0) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    convertPriceByCurrency(price, currency) {
      const conversionRates = this.$store.state.purchaseticket.currency ? this.$store.state.purchaseticket.currency.conversionRates : null;
      const priceResult = price * conversionRates[currency];
      return priceResult;
    },
    bottomVisible() {
      const scrollY = window.scrollY;
      const visible = document.documentElement.clientHeight;
      const pageHeight = document.documentElement.scrollHeight;
      const bottomOfPage = visible + scrollY >= pageHeight - 10;
      return bottomOfPage || pageHeight < visible;
    },
    refreshCart() {
      const payload = {
        customerID: this.customerID,
      };
      this.$store
        .dispatch("purchaseticket/getQtyCart", payload)
        .catch((err) => {
          console.log(err);
        });
      // this.item = this.item.map((el) => {
      //   var o = Object.assign({}, el);
      //   o.is_buy = false;
      //   return o;
      // });
    },
    togglebuy(value, index) {
      this.item[index].is_buy = value;
    },
    clickRouteInformation() { },
    addToCart(items) {
      this.selected = [];
      this.selected = items.filter((item) => item.is_buy == true).map(fare => {
        return {
          fareID: fare.fareID,
          fareType: fare.type,
          itemName: fare.name,
          qty: fare.cart_qty,
          currencyCode: fare.currencyCode,
          price: fare.price,
        }
      });

      const payload = {
        customerID: this.customerID,
        item: this.selected,
      };
      this.$store
        .dispatch("purchaseticket/addtocart", payload)
        .then((response) => {
          this.notifSuccess = true;
          this.refreshCart();
          this.item = this.item.map(fare => {
            return {
              ...fare,
              cart_qty: 0,
              is_buy: false
            }
          })
          if (response.status) console.log("success");
        })
        .catch((err) => {
          // this.notifFailed = true;
          console.log(err);
        });
    },
    buttonOke() {
      this.notifSuccess = false;
      if (this.notifSuccess == false) this.toCartPage();
    },
    buttonNo() {
      this.notifSuccess = false;
      // if (this.notifSuccess == false) this.$router.push({ name: "Cart" });
    },
    buttonOkeFailed() {
      this.notifFailed = false;
      // if (this.notifFailed == false) this.$router.push({ name: "PaymentMethodAdd" });
    },
    toCartPage() {
      // this.$router.push({ name: "Cart" });
      const cartButton = this.$partnerACL.getMetaButton('cart');
      if (cartButton) {
        if (cartButton.menu_type == "wsc_menu") {
          this.$router.push({ path: cartButton.redirect_path });
        } else {
          window.location = cartButton.redirect_path;
        }
      } else {
        this.$router.push({ name: "Cart" })
      }
    },
    async addData() {
      this.page = this.page + 1;
      var payload = {
        page: this.page,
        limit: this.limit,
        is_bundling: 1
      };
      if (this.page <= this.lastPage) {
        await this.$store
          .dispatch("purchaseticket/getSingleTripOptimize", payload)
          .then((response) => {
            this.isTicketLoaded = true;
            this.item = response.data.map((item) => {
              const tripRoute = this.$helpers.parsePgArray(item.trip_stop)
              const tripRouteCode = this.$helpers.parsePgArray(item.trip_stop_by_code)
              const routeLoc = [
                {
                  trip_id: item.trip_id,
                  trip_name: item.trip_name,
                  trip_route: tripRoute,
                  trip_route_by_code: tripRouteCode
                }
              ]
              const fareRule = {
                max_trip: item.max_trip,
                valid_days: item.valid_days,
                max_trip_perday: item.max_trip_perday,
                validate_open_date: moment(item.validate_open_date).format("yyyy-MM-DD"),
                validate_open_time: item.validate_open_time,
                expired_after_usage: item.expired_after_usage,
                expired_on_same_day: item.expired_on_same_day,
                validate_close_date: item.validate_close_date,
                validate_close_time: item.validate_close_time,
                validate_repeat_type: item.validate_repeat_type,
                selling_open_date: item.selling_open_date,
                selling_open_time: item.selling_open_time,
                selling_close_date: item.selling_close_date,
                selling_close_time: item.selling_close_time
              }
              const destLength = routeLoc[0].trip_route.length
              return {
                fareID: item.fare_id,
                name: item.name,
                type: item.type,
                currencyCode: item.currency_code,
                price: item.price,
                sellingOpenDate: item.selling_open_date,
                sellingOpenTime: item.selling_open_time,
                sellingCloseDate: item.selling_close_date,
                sellingCloseTime: item.selling_close_time,
                routeID: item.route_id,
                originID: item.origin_id,
                destinationID: item.destination_id,
                routeShortName: item.route_long_name,
                routeLongName: item.route_short_name,
                routeLoc,
                fareRule,
                addOnFare: null,
                origin_loc: routeLoc.length > 0 ? routeLoc[0].trip_route[0] : "",
                origin_code: routeLoc.length > 0 ? routeLoc[0].trip_route_by_code[0] : "",
                destination_loc: routeLoc.length > 0 ? routeLoc[0].trip_route[destLength - 1] : "",
                destination_code: routeLoc.length > 0 ? routeLoc[0].trip_route_by_code[destLength - 1] : "",
                priceStr: item.price.toString(),
                convertedPrice: this.convertPriceByCurrency(item.price, item.currency_code),
                selectedCurrency: this.$store.state.purchaseticket.currency ? this.$store.state.purchaseticket.currency.code : "",
                expiredNote: this.getExpiredNote(fareRule),
                validate_open_date: fareRule.validate_open_date ? moment.utc(fareRule.validate_open_date).format("DD-MM-YYYY") : "",
                validate_close_date: fareRule.validate_close_date ? moment.utc(fareRule.validate_close_date).format("DD-MM-YYYY") : ""
              }
            })

            this.lastPage = response.lastPage
            this.item = this.item.map((el) => {
              var o = Object.assign({}, el);
              o.is_buy = o.is_buy || false;
              return o;
            });
            if (response.page == response.lastPage) {
              this.eof = true;
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    getExpiredNote(fareRule) {
      return fareRule.expired_on_same_day ? 'ExpiredOnSameDay' :
        fareRule.valid_days != null && !fareRule.expired_on_same_day ? 'ExpiredAfterPurchase' :
          fareRule.expired_after_usage ? 'ExpiredAfterUsage' :
            fareRule.validate_close_date == null ? 'Unlimited' :
              'ValidationPeriod'
    }
  },
  destroyed() {
    window.removeEventListener("scroll", () => {
      this.bottom = this.bottomVisible();
    });
    window.removeEventListener("touchmove", () => {
      this.bottom = this.bottomVisible();
    });
  },
  async created() {
    window.addEventListener("scroll", () => {
      this.bottom = this.bottomVisible();
    });

    window.addEventListener("touchmove", () => {
      this.bottom = this.bottomVisible();
    });

    const payloadCurrency = {
      currencyCode: localStorage.getItem('currency') || "IDR",
    };
    await this.$store.dispatch("purchaseticket/getCurrencyConversionRate", payloadCurrency)
  },
  mounted() {
    window.addEventListener("scroll", () => {
      this.hasScroll = true
      // this.addData()
    })
    this.addData();
  },
};
</script>
<style lang="scss" scoped>
.center-no-ticket {
  position: absolute;
  top: 45%;
  /* position the top  edge of the element at the middle of the parent */
  left: 55%;
  /* position the left edge of the element at the middle of the parent */
  transform: translate(-50%, -50%);
  /* This is a shorthand of
                                         translateX(-50%) and translateY(-50%) */
}

/* If the screen size is 601px or more, set the font-size of <div> to 80px */
@media only screen and (min-width: 601px) {
  .home {
    background: #f5fff7;
  }

  .class-search-ticket {
    background: #f5fff7;
    margin-bottom: -10px;
  }

  .grid {
    display: grid;
  }

  .search-ticket {
    width: 100%;
    padding-left: 30%;
  }

  .footer {
    margin-top: 5%;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 70px;
    text-align: center;
    background: #ffffff;
    mix-blend-mode: normal;
    /* Field */
    box-shadow: 0px 1px 10px 0px;
  }

  .text-center {
    align-content: center;
  }
}

/* If the screen max size is 600px, set the font-size of <div> to 80px */
@media only screen and (max-width: 600px) {
  .home {
    background: #f5fff7;
  }

  .class-search-ticket {
    margin: 10px;
    background: #fdfdfd;
    margin-bottom: -10% !important;
  }

  .grid {
    display: grid;
  }

  .search-ticket {
    width: 100%;
  }

  .footer {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    text-align: center;
    background: #ffffff;
    mix-blend-mode: normal;
    /* Field */

    box-shadow: 0px 1px 10px 0px;
  }

  .text-center {
    align-content: center;
  }
}
</style>